import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../interface";
import { Preferences } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	setError: null,
};

const setError: ReduxReducer<State, State["setError"]> = (
	state,
	{ payload },
) => {
	state.setError = payload;
};

const resetError: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const errors = createSlice({
	name: Preferences.ConstantPreferencesSlice.CAR_CLASSES_ERRORS,
	initialState,
	reducers: {
		resetError,
		setError,
	},
});

export const errorsAction = errors.actions;
export const errorsReducer = errors.reducer;
export type errorsState = State;

export default errors;
